import { useAuth } from '@/hooks/useAuth';
import { normalizeCurrency } from '@/lib/currency';
import { useCoreSettings } from '@/hooks/useCoreSettings';

/**
 * useMerchantCurrency — LA devise unique du marchand.
 *
 * Le marchand choisit sa devise UNE SEULE FOIS dans
 * Paramètres → Profil → Préférences. Tout le reste s'aligne dessus :
 * le dashboard, toutes les applications installées et la boutique publique.
 *
 * Depuis le socle (spec 50), la devise est d'abord résolue par la CASCADE de
 * paramètres (Plateforme → Pays → Entreprise → Établissement → Utilisateur).
 * On retombe sur la devise du compte (users.monaie) si la cascade ne définit
 * rien. Ne jamais réintroduire de sélecteur de devise ailleurs.
 */
export function useMerchantCurrency(): string {
  const { user } = useAuth();
  const { currency } = useCoreSettings();
  return normalizeCurrency(currency || user?.monaie || 'MAD');
}

export default useMerchantCurrency;